import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { Box, Checkbox, FormControl, FormLabel, TextField, SxProps } from "@mui/material";

import { AddEntityLocationsFormData } from "../../../../../../types/editEntityProfile-type";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  } as SxProps,
  formLabel: {
    color: "var(--Dark---800, #414141)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  } as SxProps,
  checkboxContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "8px",
  } as SxProps,
} as const;

const BasicInfoTab = ({ locationIdx, branchIdx }: { locationIdx: number; branchIdx: number }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });
  const { control } = useFormContext<AddEntityLocationsFormData>();

  return (
    <Box sx={styles.container}>
      <Controller
        name={`locations.${locationIdx}.branches.${branchIdx}.branchName`}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth>
            <FormLabel sx={styles.formLabel}>{t("branchName")}</FormLabel>
            <TextField
              {...field}
              error={!!error}
              helperText={error?.message && t(error.message)}
              placeholder={t("branchNameExample")}
            />
          </FormControl>
        )}
      />
      <Controller
        name={`locations.${locationIdx}.branches.${branchIdx}.branchAddress`}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth>
            <FormLabel sx={styles.formLabel}>{t("address")}</FormLabel>
            <TextField
              {...field}
              error={!!error}
              helperText={error?.message && t(error.message)}
              placeholder={t("fullAddress")}
            />
          </FormControl>
        )}
      />
      <Controller
        name={`locations.${locationIdx}.branches.${branchIdx}.branchGoogleMapsAddress`}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth>
            <FormLabel sx={styles.formLabel}>{t("googleMapLink")}</FormLabel>
            <TextField
              {...field}
              error={!!error}
              helperText={error?.message && t(error.message)}
              placeholder={t("enterGoogleMapLink")}
            />
          </FormControl>
        )}
      />
      <Controller
        name={`locations.${locationIdx}.branches.${branchIdx}.isHeadquarters`}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth sx={styles.checkboxContainer}>
            <Checkbox {...field} size="small" />
            <FormLabel sx={styles.formLabel}>{t("headquarters")}</FormLabel>
          </FormControl>
        )}
      />
    </Box>
  );
};

export default BasicInfoTab;
